import { createSelector } from 'reselect';

const selector = state => {
  const result = state.agents.current;

  if (result) return result.asMutable({ deep: true });
}

export default createSelector(
  [selector], result => result
)



// WEBPACK FOOTER //
// ./src/selectors/current-agent-selector.js